import GridLayout from 'react-grid-layout';

export default GridLayout;